// extracted by mini-css-extract-plugin
export default {"container":"MarketplaceSwitch_container__oWz4O","button":"MarketplaceSwitch_button__mwIbx","active":"MarketplaceSwitch_active__AcZQ0"};